import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import SEO from "../../data/seo";
import HeaderTwo from "../../layout/headers/header-two";
import FooterTwo from "../../layout/footers/footer-two";
import BreadCrumb from "../common/breadcrumb";
import {getRecruitments} from "../../utils/cms.utils";
import SafeImage from "../../layout/reusable/SafeImage";

const RecruitmentIndex = () => {
    const [jobs, setJobs] = useState([]);

    useEffect(() => {
        const data = getRecruitments();
        setJobs(Array.isArray(data) ? data : []);
    }, []);

    return (
        <>
            <SEO pageTitle="Careers" />
            <HeaderTwo />

            <BreadCrumb
                title="Careers"
                items={[{ label: "Careers" }]}
            />

            <section className="recruitment section-padding">
                <div className="container">
                    <div className="recruitment__header text-center mb-60">
                        <span className="subtitle">Join Our Team</span>
                        <h2>Career Opportunities</h2>
                        <p>
                            We invite passionate professionals to grow together with us.
                            <br />
                            Kami membuka kesempatan bagi talenta terbaik untuk berkembang bersama.
                        </p>
                    </div>


                    <div className="divider"/>

                    <div className="row">
                        {jobs.length === 0 && (
                            <p className="text-center muted mt-10 mb-10">
                                No open positions at the moment.
                            </p>
                        )}

                        {jobs.map((job) => (
                            <div key={job.id} className="col-lg-6 mb-30">
                                <Link
                                    to={`/recruitment/${job.id}`}
                                    className="recruitment-card"
                                >
                                    <div className="recruitment-card__image">
                                        <SafeImage
                                            src={job.image}
                                            alt={job.positionEn}
                                        />
                                    </div>

                                    <div className="recruitment-card__content">
                                        <span className="recruitment-card__badge">
                                            {job.typeEn}
                                        </span>

                                        <h4>{job.positionEn}</h4>
                                        <p className="position-id">
                                            {job.positionId}
                                        </p>

                                        <div className="recruitment-card__date">
                                            Open until{" "}
                                            {new Date(job.closeDate).toLocaleDateString()}
                                        </div>

                                        <span className="recruitment-card__cta">
                                            View Details →
                                        </span>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <FooterTwo />
        </>
    );
};

export default RecruitmentIndex;
